import React, { useState, useEffect, useCallback } from "react";
import { Theme, makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import UserTable from "../components/user-table";
import { CompoentLoading } from "../views/loading";
import { IUsers } from "../interface/users";
import UserChart from "../components/user-chart";

interface IUsersData {
  meaUsers: IUsers[];
  customerUsers: IUsers[];
}

const useStyle = makeStyles((theme: Theme) => ({
  gridHeight: {
    height: `calc(100vh - ${theme.spacing(35.75)}px)`,
    position: "relative",
  },
  gridRightContent: {
    height: `calc(100% + ${theme.spacing(2)}px)`,
    position: "relative",
  },
  subGridTop: {
    height: `calc(50% - ${theme.spacing(1)}px)`,
  },
  subGridBottom: {
    height: `calc(50% + ${theme.spacing(1)}px)`,
  },
}));

interface DepartmentId {
  selectDepartment: string | number;
  userList: any[];
}

const DashboardAllUser = (props: DepartmentId) => {
  const classes = useStyle();
  const [loading, setloading] = useState<Boolean>(true);
  const [usersData, setusersData] = useState<IUsersData>({
    meaUsers: [],
    customerUsers: [],
  });
  const { selectDepartment, userList } = props;

  const initData = useCallback(async () => {
    const meaUsers = userList.filter((us: any) => us.role !== "customer");
    const customerUsers = userList.filter((us: any) => us.role === "customer");
    setusersData({
      meaUsers: selectDepartment
        ? meaUsers.filter((us: any) => us.project)
        : meaUsers,
      customerUsers: selectDepartment
        ? customerUsers.filter((us: any) => us.project)
        : customerUsers,
    });
    setloading(false);
  }, [userList, selectDepartment]);

  useEffect(() => {
    if (userList.length) {
      setloading(true);
      initData();
    }
    return () => {};
  }, [initData, userList]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={4} className={classes.gridHeight}>
        <UserChart usersData={usersData} />
      </Grid>
      <Grid item xs={8} className={classes.gridHeight}>
        <Grid container spacing={2} className={classes.gridRightContent}>
          <Grid item xs={12} className={classes.subGridTop}>
            {loading ? (
              <CompoentLoading />
            ) : (
              <UserTable title="MEA User" data={usersData.meaUsers} />
            )}
          </Grid>
          <Grid item xs={12} className={classes.subGridBottom}>
            {loading ? (
              <CompoentLoading />
            ) : (
              <UserTable title="Customer User" data={usersData.customerUsers} />
            )}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default DashboardAllUser;
